/**
 * @module FE-CU46_サービス追加画面
 */
import Header from '../../components/header/Header.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NativeApi from '../../api/nativeApi';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU46';

export default {
  name: 'ServiceAdd',
  components: {
    Header,
    MobileFooter,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
  },
  data() {
    return {
      service: {},
      deviceID: '',
      deviceIDError: '',
      customerNumber1: '',
      customerNumber2: '',
      customerNumberError1: '',
      customerNumberError2: '',
      certificationNumber1: '',
      certificationNumber2: '',
      certificationNumberError1: '',
      certificationNumberError2: '',
      isValid: false,
      dialogSelectItem: {},
      takeoverFlg: false,
      simpleServiceList: [],
      initSimpleServiceStr: [],
      modifiedSimpleService: '',
    };
  },
  created() {
    this.service = { id: 1, text: 'ホームセキュリティ' };
  },
  computed: {
    btnDisabledCheck() {
      let disabled = true;
      switch (this.service.id) {
        case CONSTANTS.SERVICE_TO_ADD.HOME_SECURITY:
          // ホームセキュリティ
          disabled =
            this.hasErrorInRules(this.customerNumberRule1) ||
            this.hasErrorInRules(this.certificationNumberRule1);
          break;
        case CONSTANTS.SERVICE_TO_ADD.CAMERA:
          // カメラ
          if (
            /^[0-9a-zA-Z]+$/.test(this.deviceID) &&
            ((/^[0-9]+$/.test(this.customerNumber2) &&
              /^[0-9]+$/.test(this.certificationNumber2)) ||
              (this.customerNumber2 === '' && this.certificationNumber2 === ''))
          ) {
            disabled = false;
          } else {
            disabled = true;
          }
          break;
        case CONSTANTS.SERVICE_TO_ADD.OTHER_SERVICES:
          // 簡易サービス(変更がある場合のみ活性)
          disabled =
            this.initSimpleServiceStr === JSON.stringify(this.simpleServiceList) ||
            this.simpleServiceList.length === 0;
          break;
      }
      return disabled;
    },
    isSelectHomeSecurity: {
      get() {
        return this.service.id === CONSTANTS.SERVICE_TO_ADD.HOME_SECURITY;
      },
    },
    isSelectCamera: {
      get() {
        return this.service.id === CONSTANTS.SERVICE_TO_ADD.CAMERA;
      },
    },
    isSelectOtherServices: {
      get() {
        return this.service.id === CONSTANTS.SERVICE_TO_ADD.OTHER_SERVICES;
      },
    },
    i18nItems(vm) {
      {
        return {
          title: vm.$vuetify.lang.t('$vuetify.FECU46サービス追加画面.サービス追加'),
          hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.C0001'),
          services: [
            {
              id: 1,
              text: vm.$vuetify.lang.t(
                '$vuetify.FECU46サービス追加画面.追加したいサービスセレクト.ホームセキュリティ'
              ),
            },
            {
              id: 2,
              text: vm.$vuetify.lang.t(
                '$vuetify.FECU46サービス追加画面.追加したいサービスセレクト.カメラ'
              ),
            },
            {
              id: 3,
              text: vm.$vuetify.lang.t(
                '$vuetify.FECU46サービス追加画面.追加したいサービスセレクト.その他サービス'
              ),
            },
          ],
          placeholder: {
            半角数字6桁: vm.$vuetify.lang.t('$vuetify.FECU46サービス追加画面.半角数字6桁'),
            半角数字9桁: vm.$vuetify.lang.t('$vuetify.FECU46サービス追加画面.半角数字9桁'),
            半角英数字15桁: vm.$vuetify.lang.t('$vuetify.FECU46サービス追加画面.半角英数字15桁'),
            半角英数字24桁: vm.$vuetify.lang.t('$vuetify.FECU46サービス追加画面.半角英数字24桁'),
          },
        };
      }
    },
    /**
     * お客様番号 バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    customerNumberRule1() {
      return [
        !!this.customerNumber1 ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0001'),
        /^[0-9]*$/.test(this.customerNumber1) ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0002'),
      ];
    },
    /**
     * お客様番号 バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    customerNumberRule2() {
      return [
        /^[0-9]*$/.test(this.customerNumber2) ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0002'),
      ];
    },
    /**
     * 認証番号 バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    certificationNumberRule1() {
      return [
        !!this.certificationNumber1 ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0007'),
        /^[0-9]*$/.test(this.certificationNumber1) ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0015'),
      ];
    },
    /**
     * 認証番号 バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    certificationNumberRule2() {
      return [
        /^[0-9]*$/.test(this.certificationNumber2) ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0015'),
      ];
    },
    /**
     * デバイスID バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    deviceIDRule() {
      return [
        !!this.deviceID ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0009'),
        /^[0-9a-zA-Z]+$/.test(this.deviceID) ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0011'),
      ];
    },
    /**
     * ヘッダーに戻るボタンを表示するか
     * @returns {boolean} ヘッダーに戻るボタンを表示するか
     * @description アプリから遷移した場合は戻るボタンを表示しない
     */
    displayBackButton() {
      return this.$mq === 'pc' ? true : !(this.$route.query.takeoverToken && this.$isBrowser);
    },
    customerNumber: {
      get() {
        if (this.service.id == 1) {
          return this.customerNumber1;
        } else if (this.service.id == 2) {
          return this.customerNumber2;
        }
      },
      set(value) {
        if (this.service.id == 1) {
          this.customerNumber1 = value;
        } else if (this.service.id == 2) {
          this.customerNumber2 = value;
        }
      },
    },
    certificationNumber: {
      get() {
        if (this.service.id == 1) {
          return this.certificationNumber1;
        } else if (this.service.id == 2) {
          return this.certificationNumber2;
        }
      },
      set(value) {
        if (this.service.id == 1) {
          this.certificationNumber1 = value;
        } else if (this.service.id == 2) {
          this.certificationNumber2 = value;
        }
      },
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 登録ボタン押下時のアクション
     */
    async callSaveAgreementDialogDialog() {
      // ホームセキュリティまたは、カメラでお客様番号/認証番号が入力されていない場合の処理
      if (
        this.isSelectHomeSecurity ||
        (this.isSelectCamera && !this.customerNumber && !this.certificationNumber) ||
        this.isSelectOtherServices
      ) {
        const result = await this.$agreementDialog(
          '$vuetify.agreementDialog.確認',
          '$vuetify.メッセージ一覧.FECU46サービス追加画面.C0002',
          '$vuetify.agreementDialog.いいえボタン',
          '$vuetify.agreementDialog.はいボタン'
        );

        if (result === true) {
          // OK 登録完了ダイアログを表示
          if (this.isSelectHomeSecurity) {
            // ホームセキュリティの場合
            await this.APP_CU4601();
          } else if (this.isSelectOtherServices) {
            // その他サービスの場合
            await this.APP_CU4604();
          } else {
            // カメラの場合
            // お客様番号/認証番号が入力されていない場合
            let data = await this.APP_CU4603();
            if (data.contentsInfo.serviceAddErrorCode == 0) {
              this.openHomeLink(data.contentsInfo);
            }
          }
        } else {
          // キャンセル
        }
      } else {
        this.callSaveAgreementSelectDialog();
      }
    },
    /**
     * 地区選択ダイアログ
     */
    async callSaveAgreementSelectDialog() {
      // カメラでお客様番号/認証番号が入力されている場合の処理
      let selects = await this.APP_CU4602();

      // 空の場合(紐づく表示地区情報がない)
      if (selects.length > 0) {
        const result = await this.$agreementSelectDialog(
          '$vuetify.agreementSelectDialog.確認',
          '$vuetify.メッセージ一覧.FECU46サービス追加画面.C0004',
          '$vuetify.agreementSelectDialog.戻る',
          '$vuetify.agreementSelectDialog.登録',
          selects
        );
        if (result === true) {
          // 登録
          const result = await this.$agreementDialog(
            '$vuetify.agreementDialog.確認',
            '$vuetify.メッセージ一覧.FECU46サービス追加画面.C0002',
            '$vuetify.agreementDialog.いいえボタン',
            '$vuetify.agreementDialog.はいボタン'
          );
          if (result === true) {
            let data = await this.APP_CU4603();
            if (data.contentsInfo.serviceAddErrorCode == 0) {
              this.openHomeLink(data.contentsInfo);
            }
          } else {
            // キャンセル
          }
        } else {
          // キャンセル
        }
      } else {
        this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0018');
      }
    },
    /**
     * APP_CU4602_表示情報取得API実行
     * @returns {Array} 表示地区情報リスト
     */
    APP_CU4602: async function () {
      this.$_setLoading(true);

      let param = '/api/serviceAdd/getDisplayDistrictInfo'; // 本番用
      // let param = "post"; // 検証用

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.customerNumber,
        authenticationNumber: this.certificationNumber,
      };
      let method = 'post';
      let apiData = '';
      let selects = [];
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: [
            //       {
            //         displayDistrictNickname: "displayDistrictNickname",
            //         customerNumber: "falcustomerNumberse",
            //         districtSplitNumber: "districtSplitNumber",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname2",
            //         customerNumber: "falcustomerNumberse2",
            //         districtSplitNumber: "districtSplitNumber2",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname3",
            //         customerNumber: "falcustomerNumberse3",
            //         districtSplitNumber: "districtSplitNumber3",
            //       },
            //     ],
            //   },
            // };

            // 対象地区選択ダイアログに設定
            apiData.contentsInfo.displayDistrictInfo.forEach((item) => {
              selects.push({
                id: item.districtSplitNumber, // 表示用
                text: item.displayDistrictNickname, // 表示用
                displayDistrictNickname: item.displayDistrictNickname, // 登録時に必要
                customerNumber: item.customerNumber, // 登録時に必要
                districtSplitNumber: item.districtSplitNumber, // 登録時に必要
              });
            });
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return selects;
    },
    /**
     * APP_CU4601_登録(ホームセキュリティ)API実行
     */
    APP_CU4601: async function () {
      this.$_setLoading(true);

      let param = '/api/serviceAdd/registrationHomeSecurity'; // 本番用
      // let param = "post"; // 検証用
      let method = 'post';
      let apiData = null;
      let result = {};

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.customerNumber,
        authenticationNumber: this.certificationNumber,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     serviceAddErrorCode: 0,
            //   },
            // };
            // レスポンスをセット
            result = apiData.contentsInfo;

            if (result.serviceAddErrorCode === 0) {
              this.callMessageDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.C0006');
            } else if (result.serviceAddErrorCode === 1) {
              // サービス追加失敗ダイアログを発火
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0016');
            } else if (result.serviceAddErrorCode === 2) {
              // メインユーザー既に登録済みダイアログを発火
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0012');
            }
          },
          (error) => {
            // 異常系処理
            if (error.response.status == 400) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0013');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * APP_CU4603_登録(カメラ)API実行
     * @returns apiData APP_CU4603レスポンス
     */
    APP_CU4603: async function () {
      this.$_setLoading(true);

      let param = '/api/serviceAdd/registrationCamera'; // 本番用
      // let param = "post"; // 検証用
      let method = 'post';
      let apiData = null;

      let districtSplitNumber = {};
      if (!!this.customerNumber && !!this.certificationNumber) {
        districtSplitNumber = this.$store.state.agreementSelectDialogSelectItem.districtSplitNumber;
      }
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.deviceID,
        customerNumber: this.customerNumber,
        authenticationNumber: this.certificationNumber,
        districtSplitNumber: districtSplitNumber,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // 仮レスポンス
            // apiData = {
            //   contentsInfo: {
            //     serviceAddErrorCode: 0,
            //     webAuthenticationParameter: {
            //       clientId: "clientId",
            //       state: "state",
            //       oneTimeUrlId: "oneTimeUrlId",
            //     },
            //     checkOneTimeUrlId: "checkOneTimeUrlId",
            //   },
            // };
            // サービス追加エラーコード==0: 登録完了のとき
            if (apiData.contentsInfo.serviceAddErrorCode === 0) {
              localStorage.setItem(
                'client_id',
                apiData.contentsInfo.webAuthenticationParameter.client_id
              );
              localStorage.setItem('state', apiData.contentsInfo.webAuthenticationParameter.state);
              localStorage.setItem(
                'oneTimeUrlId',
                apiData.contentsInfo.webAuthenticationParameter.oneTimeUrlId
              );
            } else if (apiData.contentsInfo.serviceAddErrorCode === 2) {
              // サービス追加エラーコード==2: メインユーザー登録済みのとき
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0012');
            }
          },
          (error) => {
            if (error.response.status == 400) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0013');
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * ダミー画面（cameraAuth）を別タブで開く
     * @param {object} contentsInfo APP_CU4603レスポンス
     */
    async openHomeLink(contentsInfo) {
      // No.38のダイアログを表示する。
      const result = await this.$informationDialog(
        '$vuetify.メッセージ一覧.FECU46サービス追加画面.C0005'
      );
      if (result === true) {
        if (this.$isMobileApp) {
          // ブラウザアプリでcameraAuthを開く
          const userAgent = navigator.userAgent;
          let os = '';
          if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            os = 'ios';
          }
          if (/android/i.test(userAgent)) {
            os = 'android';
          }
          NativeApi.openBrowserApp(
            location.origin + '/' + (os == 'ios' ? encodeURIComponent('#') : '#') + '/cameraAuth'
          );
        } else {
          // cameraAuthを別タブで開く
          window.open('/#/cameraAuth', '_blank');
        }

        // 繰り返し実行
        await this.APP_CO9902(contentsInfo);
      }
    },
    /**
     * APP_CU4604_登録(その他サービス)API実行
     */
    APP_CU4604: async function () {
      this.$_setLoading(true);

      let param = '/api/serviceAdd/registrationSimpleService';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        serviceList: this.simpleServiceList,
        modified: this.modifiedSimpleService,
      };
      let method = 'post';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // レスポンスなし
            this.callMessageDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.C0006');
          },
          (error) => {
            // 異常系処理
            if (error.response.status == 400) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0013');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * APP_CO9902_カメラ連携完了チェック
     * @param {object} contentsInfo APP_CU4603レスポンス
     */
    APP_CO9902: async function (contentsInfo) {
      this.$_setLoading(true);

      let apiData = '';
      let queries = {
        oneTimeUrlId: contentsInfo.checkOneTimeUrlId,
      };
      await this.$store
        .dispatch(`requestApi/postCameraCoordinationCheck`, {
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = response;
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 1,
            //     cameraCoordinationResult: 2,
            //   },
            // };

            if (apiData.contentsInfo.cameraCoordinationResult == 0) {
              // No.38のダイアログを表示する。
              this.callMessageDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.C0006');
            } else if (apiData.contentsInfo.cameraCoordinationResult == 1) {
              // No.31のダイアログを表示する。
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0013');
            } else if (apiData.contentsInfo.cameraCoordinationResult == 2) {
              // 3分以上経過した場合
              // エラーダイアログ（No.31のダイアログ）を表示し、APP_CO9902の繰り返し実行を止める。
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0013');
              // 3分未満
              // APP_CO9902 APIを再度実行。 requestApi/postCameraCoordinationCheck で実行
            } else if (apiData.contentsInfo.cameraCoordinationResult == 3) {
              // No.40のダイアログを表示する。
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0017');
            }
          },
          (error) => {
            if (error.response.status == 400) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU46サービス追加画面.E0019');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * ユーザー権限一覧取得API実行処理
     */
    async APP_CU9916() {
      let param = '/api/common/getRoleList';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: {
            //       customerNumber: "sendCustomerNumber",
            //       districtSplitNumber: "sendCustomerNumber",
            //       displayDistrictUserType: 1,
            //       userAuthority: {
            //         securityOperation: true,
            //         rushOrder: true,
            //         notificationHistory: true,
            //         deviceContorol: true,
            //         contact: true,
            //         nicknameSetting: true,
            //         IDCardKeyInfoSetting: true,
            //         watchOverInfoDeliverySetting: true,
            //         lockUpCheck: true,
            //         targetAtHomeSetting: true,
            //         userManagement: true,
            //         emergencyContact: true,
            //       },
            //     },
            //     cameraInfoList: {
            //       customerNumber: "customerNumber",
            //       districtSplitNumber: "districtSplitNumber",
            //       deviceID: "deviceID",
            //       cameraUserType: 0,
            //       userAuthority: {
            //         anticrimeCameraVideos: false,
            //         rushOrder: false,
            //         notificationHistory: false,
            //         contact: false,
            //         nicknameSetting: false,
            //         userManagement: false,
            //         emergencyContact: false,
            //       },
            //     },
            //   },
            // };

            if (apiData.contentsInfo.displayDistrictInfoList.length != 0) {
              this.$store.state.isTopHomeSecurityActive = true;
            }

            if (apiData.contentsInfo.cameraInfoList.length != 0) {
              this.$store.state.isTopCameraActive = true;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
    },
    /**
     * APP_CO9913_継続ログイン認証
     */
    async APP_CU9913() {
      let param = '/api/common/continueLogin';
      let queries = {
        takeOverToken: this.$route.query.takeoverToken,
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo:{
            //     loginResult: 0   // 0: ログイン成功 | 1: 2段階認証が必要 | 2: ログイン失敗
            //   },
            //   token: "string"
            // }
            this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
            switch (apiData.contentsInfo.loginResult) {
              case 0: {
                this.$store.commit('setIsLoggedIn', { isLoggedIn: true });
                sessionStorage.setItem('token', apiData.token);
                // 権限取得APP_CU9916
                await this.APP_CU9916();
                if (this.$store.getters['isLoggedIn']) {
                  await this.$refs.header.APP_CU0201();
                  //簡易サービス追加 初期表示(APP_CU4605)
                  await this.APP_CU4605();
                }
                break;
              }
              case 1: {
                let handoverToken = apiData.token;
                this.$router.push({
                  path: '/twoStepAuthentication',
                  query: {
                    handoverToken: handoverToken,
                    targetPage: '/serviceAdd',
                  },
                });
                break;
              }
              case 2: {
                this.$_abnormality(500);
                break;
              }
              default: {
                this.$_abnormality(500);
                break;
              }
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 初期表示(APP_CU4605)
     */
    APP_CU4605: async function () {
      this.$_setLoading(true);

      let param = '/api/serviceAdd/init';
      // let param = 'post';

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     simpleServiceInfo: {
            //       serviceList: [
            //         {
            //           id: 1,
            //           serviceName: "スマート<BR>ロック",
            //           serviceNameEN: "Smart<BR>Lock",
            //           registered: true,
            //         },
            //         {
            //           id: 2,
            //           serviceName: "資料請求",
            //           serviceNameEN: "Document<BR>Request",
            //           registered: false,
            //         },
            //       ],
            //       modified: "2024-02-01 12:00:00",
            //     },
            //   },
            // };

            apiData.contentsInfo.simpleServiceInfo.serviceList.forEach((element) => {
              this.simpleServiceList.push({
                id: element.id,
                serviceName: element.serviceName.replace(/<BR>/g, ''),
                serviceNameEN: element.serviceNameEN.replace(/<BR>/g, ''),
                registered: element.registered,
              });
            });
            this.modifiedSimpleService = apiData.contentsInfo.simpleServiceInfo.modified;
            // 初期表示の簡易サービスチェック状態を保持
            this.initSimpleServiceStr = JSON.stringify(this.simpleServiceList);
          },
          (error /* eslint-disable-line */) => {
            // 異常系の処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * お知らせダイアログ
     * @param {string} text ダイアログメッセージ
     */
    async callMessageDialog(text) {
      await this.$informationDialog(text);
      // Thanks画面に遷移する。
      sessionStorage.removeItem('token');
      this.$store.commit('setThanksType', {
        fromPageInfo: { page: 46 },
        displayType: 3,
      });
      this.$router.push('thanks');
    },
    /**
     * 入力チェックエラーの有無判定処理
     * @param {Array} rules
     * @returns {boolean} エラーがあるかどうか
     */
    hasErrorInRules: function (rules) {
      return rules.some((rule) => rule !== true);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // アプリから遷移時orリロード時
      if (from.path == '/') {
        vm.takeoverFlg = true;
        next();
      } else {
        next();
      }
    });
  },
  async mounted() {
    if (this.$route.query.takeoverToken && this.$isBrowser && this.takeoverFlg) {
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: false });
    }
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    // 継続ログイン認証APP_CU9913
    if (this.$route.query.takeoverToken && this.$isBrowser && !this.$store.state.takeoverTokenFlg) {
      this.$store.commit('setIsLoggedIn', { isLoggedIn: false });
      await this.APP_CU9913();
    } else {
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
      if (this.$store.getters['isLoggedIn']) {
        await this.$refs.header.APP_CU0201();
        //簡易サービス追加 初期表示(APP_CU4605)
        await this.APP_CU4605();
      }
    }
  },
};
